module.exports = __webpack_public_path__ + "img/1.a44f2344.png";